import { type EdgeData, isTopologyEdgeData } from '@ipfabric/utils';
import { initialTechnologies } from 'components/Graph/GraphState';
import { applyTopologySettings } from 'components/Graph/commands/applyTopologySettings';
import { setGroupedEdge } from 'components/Graph/commands/setGroupedEdge';
import { submitTechnologies } from 'components/Graph/commands/topology/submitTechnologies';
import { updateStpInstance } from 'components/Graph/commands/updateStpInstance';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import deepEqual from 'react-fast-compare';

interface UngroupEdgeCommand {
  edgeData: EdgeData;
}

export const ungroupEdge: GraphCommandFactory<UngroupEdgeCommand> =
  (cmdContext, dispatch) => (command) => {
    if (
      isTopologyEdgeData(command.edgeData) &&
      command.edgeData.relatedTechnology
    ) {
      const { relatedTechnology } = command.edgeData;
      const {
        technologies: {
          selectedTechnologies: {
            stpInstances = initialTechnologies.stpInstances,
          },
        },
      } = cmdContext.getState();

      const instance = stpInstances.instances.find(
        ({ rootId, vlanId }) =>
          rootId === relatedTechnology.rootId &&
          vlanId === relatedTechnology.vlanId,
      );

      if (instance?.grouped) {
        dispatch(updateStpInstance, {
          instance: { ...instance, grouped: false },
        });

        dispatch(submitTechnologies);
      }
    } else {
      const {
        layoutSettings: {
          presetDraft: { edges: originalEdges },
        },
      } = cmdContext.getState();
      dispatch(setGroupedEdge, {
        grouped: false,
        edgeSettingsId: command.edgeData.edgeSettingsId,
      });
      const {
        layoutSettings: {
          presetDraft: { edges: updatedEdges },
        },
      } = cmdContext.getState();
      if (!deepEqual(originalEdges, updatedEdges)) {
        // Intentionaly apply settings even if not selected to apply immediately
        dispatch(applyTopologySettings);
      }
    }
  };
